/*
 * @Description: 功能描述
 * @Author: yy
 * @Date: 2019-05-31 14:47:28
 * @LastEditors: yy
 * @LastEditTime: 2021-04-13 15:40:44
 */
/**
 * React Starter Kit (https://www.reactstarterkit.com/)
 *
 * Copyright © 2014-present Kriasoft, LLC. All rights reserved.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.txt file in the root directory of this source tree.
 */

import React from 'react';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import s from './p30.css';

import ExportHeadTitle from '../../../components/ExportHeadTitle/ExportHeadTitle';
import ExportDes from '../../../components/ExportDes/ExportDes';
import ExportFootDes from '../../../components/ExportFootDes/ExportFootDes';
import ExportTable from '../../../components/ExportTable/ExportTable';

import {IconUrl, saasBrandDBGetBrandDBList, saasBrandDBSaveBrandDBList} from '../../../controller';
import { toThousands } from '../../../utils';
import moment from 'moment';
import TimeInput from '../../../components/TimeInput/TimeInput';
import SelectIndustry from '../../../components/SelectIndustry/SelectIndustry';

class P30 extends React.Component {
  textareaRef = null
  state = {
    query: {
      brandNames: '',
      startDate: '',
      statisDate: ''
    },

    list: [],
    prevChart: {},
    chart: {},

    // ---------------------
    industry: {
      id: 152,
      name: "电子烟"
    },
    brands: [],
    begin: moment().format('YYYY-MM-DD'),
    end: moment().format('YYYY-MM-DD'),
  }

  setDate = (name, val) => {
    this.setState({
      [name]: val
    })
  }

  onSubmit = () => {
    const {begin, end, industry} = this.state
    const val = this.textareaRef.value

    saasBrandDBGetBrandDBList({
      industryId: industry.id + '',
      startTime: begin,
      endTime: end,
      lastShareOfMind: this.getTextarea(val)
    }).then(res => {
      this.setState({
        list: res.result
      })
    })
  }
  
  exportExcel = () => {
    const {begin, end, industry} = this.state
    const val = this.textareaRef.value
    saasBrandDBSaveBrandDBList({
      industryId: industry.id + '',
      startTime: begin,
      endTime: end,
      lastShareOfMind: this.getTextarea(val)
    }).then(res => {
      var alink= document.createElement('a');  
      alink.style.display = 'none'  
      alink.href = window.URL.createObjectURL(res);  
      alink.download = `${industry.name}-${begin}-${end}.xlsx`
      document.body.appendChild(alink)
      alink.click()
      URL.revokeObjectURL(alink.href)
      document.body.removeChild(alink)
    })
  }


  getTextarea = (val) => {
    let result = {}
    if (!val) return result
    val.trim().split(/[\r\n]/).filter(v => !!v).forEach(element => {
      console.log(element);
      const [_d, name, val] = /(.+?)\s+(\d+([\.]\d+){0,})/.exec(element)
      result[name] = val *100 / 10000
    });
    return result
  }

  onBlur = (e) => {
    console.log(e.target.value);
  }
  onChangeIndustry = (val) => {
    this.setState({
      industry: {
        id: val.id,
        name: val.name
      }
    })
  }

  render() {
    const {query, list, begin, end, industry} = this.state;
    const column = [
      {name: '排名', key: 'ranking', width: 60, minWidth: 60},
      {name: '品牌名称', key: 'name', render: (d, item) => {
        return (
          <div>
            <img className={s.icon} src={IconUrl(item.id)} />
            <span>{d}</span>
          </div>
        )
      }},
      {name: 'DB总值', key: 'db'},
      {name: '（行业内）心智占有率', key: 'shareOfMind'},
      {name: '（行业内）心智占有率涨跌', key: 'riseAndFall'},
    ]
    return (
      <div className={s.container}>
        <div style={{
            position: 'absolute',
            left: '100%',
            top: 0,
            boxShadow: '0 0 5px #000',
            padding: 5
          }}>
          <div>
            <h3>行业</h3>
            <SelectIndustry defaultValue={industry.name} onSelect={this.onChangeIndustry} />
          </div>
          <div>
            <h3>上次报告数据</h3>
            <textarea ref={e => this.textareaRef = e} onBlur={this.onBlur}></textarea>
            <p>请输入品牌名和数据，每行一条</p>
          </div>
          <div>
            <h3>本次报告时间</h3>
            <label>
              <span>开始时间</span>
              <TimeInput className={s.input} value={begin} onChange={val => this.setDate('begin', val)} />
            </label>
            <label>
              <span>开始时间</span>
              <TimeInput className={s.input} value={end} onChange={val => this.setDate('end', val)} />
            </label>
          </div>
          <div>
            <button onClick={this.onSubmit}>确定</button>
            <button onClick={this.exportExcel}>下载excel</button>
          </div>
        </div>
        <ExportHeadTitle>行业排行榜</ExportHeadTitle>

        <div style={{
          display: 'none',
          paddingTop: list.length > 4 ? '10px' : '0'
        }}>
          <ExportDes>
            截止2月19日，电子烟榜单中，悦刻保持第一，其心智占有率相较上月（1月19日）而言，微跌0.7% 
          </ExportDes>
        </div>
        <div style={{maxHeight: 600, overflow: 'auto'}}>
          <ExportTable
            hasClass='borderTable'
            column={column}
            list={list.filter((e, i) => i < 20).map((item, i) => ({
              id: item.id,
              name: item.name,
              ranking: i + 1,
              db: toThousands(item.db),
              shareOfMind: item.shareOfMind + '%',
              riseAndFall: item.riseAndFall + '%',
            }))} />
        </div>
        <ExportFootDes
          brandName={query.brandNames}
          beginTime={query.startDate}
          endTime={query.statisDate} />
      </div>
    );
  }
}

export default withStyles(s)(P30);



// WEBPACK FOOTER //
// src/routes/exportPDF/p30/p30.js